import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { deleteNotification, getNotificationList } from 'app/api/notification';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { dataformatChangesYearToDateandTime } from 'app/utils/Parsers';
const useNotificationManagement = () => {
  const navigate = useNavigate();
  const sectionObj = {
    sectionTitle: APP_CONSTANTS.NOTIFICATION_TAG,
    searchObj: {
      keys: ['name'],
      placeholder: 'Search by Name, Title',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
        // inputChangeHandler(e);
      },
    },
    buttons: [
      {
        customclassName: 'bg-white margin-right-class',
        imgTrue: false,
        title: 'Filter',
        handleBtnClick: () => {
          setIsFilterOpen(!isFilterOpen);
        },
      },
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_NOTIFICATION_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_NOTIFICATION}`);
        },
      },
    ],
  };
  const [values, setValues] = useState({
    name: '',
    title: '',
  });
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);

  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering
  const [totalNumber, setTotalNumber] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false); // New state to track filtering

  const fetchNotificationData = useCallback(
    async (page, searchValue = '', filters = {}) => {
      setPageLoading(true);
      try {
        const response = await getNotificationList(
          page,
          dataPerPage,
          searchValue,
          filters.name,
          filters.title
        );
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.notifications || [];
          const newArray = dataArr.map((item) => ({
            ...item,
            name: item?.name || '',
            title: item?.title || '',
            tierName: item?.sourcePayload?.tierName || '',
            mallName: item?.sourcePayload?.mallName || '',
            status: item?.status ? 'Active' : 'Inactive',
            gender: item?.gender?.gender,
            dateTime: dataformatChangesYearToDateandTime(item?.createdAt) || '',
          }));
          setData(newArray);
          setFilteredData(newArray);
          setIsdeleteFiltering(false);
          const totalCount = response?.data?.total || 0;
          setTotalNumber(totalCount);
          const tempcount = Math.ceil(totalCount / dataPerPage);

          setPageCount(tempcount);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );
  const callServiePublishOrUnpublishAPI = async (data, value) => {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteNotification(data?.id);
      setPageLoading(false);
      setIsdeleteFiltering(true);
      if (responseObj?.responseCode === 200) {
        Toast.success('Notification Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    }
  };
  function handleFiltering() {
    try {
      if (!data || !Array.isArray(data)) {
        throw new Error('Data is not defined or not an array');
      }

      if (!values) {
        throw new Error('Values are not defined');
      }

      const filtered = data.filter((item) => {
        let isMallMatching =
          !values.title ||
          item?.title?.toLowerCase().includes(values.title.toLowerCase());

        let isStoreMatching =
          !values.name ||
          item?.name?.toLowerCase().includes(values.name.toLowerCase());

        return isMallMatching && isStoreMatching;
      });

      setFilteredData(filtered);
    } catch (error) {
      console.error('Error in handleFiltering:', error.message);
    }
  }
  useEffect(() => {
    if (isFiltering) {
      handleFiltering();
      setIsFiltering(false);
    }
  }, [isFilterOpen, isFiltering, data, values, filteredData]);
  const handleDelete = (data) => {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete ${data?.name} this Notification?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            callServiePublishOrUnpublishAPI(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  };
  // ------------------------------------------------

  function handleEdit(data) {
    navigate(`/notification/edit/:${data?.id}`, {
      state: {
        ...data,
      },
    });
  }
  function handleSubmit(event) {
    event.preventDefault();
    setIsFiltering(true);
  }
  function resetfilterModel() {
    setValues({
      name: '',
      title: '',
    });
    setFilteredData([]);
    setIsFiltering(true);
  }
  function handleFilterCancel() {
    setIsFilterOpen(false);
  }
  return {
    handleFilterCancel,
    resetfilterModel,
    handleDelete,
    pageLoading,
    data,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    handleEdit,
    totalNumber,
    sectionObj,
    filteredData,
    setValues,
    values,
    isFilterOpen,
    setIsFilterOpen,
    handleSubmit,
    fetchNotificationData,
    isdeleteFiltering,
  };
};

export default useNotificationManagement;
